<p-toolbar class="align-items-center list-toolbar">
  <div class="p-toolbar-group-left">
      <span class="list-title" i18n="@@search-list-search-via-list">Search via list</span><span>&nbsp;({{totalRecords}})</span>
  </div>

  <div class="p-toolbar-group-right">
    <app-configure-filters uniqueKey="searchTable"></app-configure-filters>
    <p-button icon="fa fa-solid fa-filter-circle-xmark" label="" (onClick)="genericListComponent.clearFilters()"
              severity="secondary" class="mr-1 ml-1">
    </p-button>
    <app-global-search uniqueKey="searchTable"></app-global-search>
    <app-configure-fields [allColumns]="allColumns" [visibleColumnKeys]="visibleColumnKeys" (visibleColumnsEvent)="visibleColumnKeys = $event"
                          uniqueKey="searchTable">
    </app-configure-fields>
    <p-button icon="fa fa-solid fa-download" i18n-label="@@common-export" label="Export"
              (onClick)="onClickDownload()" class="ml-1">
    </p-button>
  </div>
</p-toolbar>

<app-generic-list [tableReloadObservable]="tableReloadSubject.asObservable()" [onLazyLoad]="load" [api]="api"
                  (dataChange)="totalRecords = $event.count || 0" [visibleColumnKeys]="visibleColumnKeys" (columnsLoad)="allColumns = $event"
                  selectionMode="single" [onRowClick]="rowClick" dataKey="uuid" [prefixDetailUrlTemplate]="detailCreateUrl"
                  [rowClassCallable]="getRowClass"
                  [multiSortMeta]="[{field: 'state', order: -1},
                                    {field: 'country__' + filterLabelField, order: 1},
                                    {field: 'place__name', order: 1},
                                    {field: 'date', order: -1}]" uniqueKey="searchTable">

  <app-generic-column key="country__code_iso" [sortKey]="'country__' + filterLabelField"
                      [filterType]="FilterType.MSELECT" [filterOptions]="countries" [filterLabelField]="filterLabelField" filterValueField="code_iso"
                      i18n-title="@@search-list-country" title="Country">
    <ng-template let-item>
      <app-flag [country]="countryForFlag(identity(item))"/>
    </ng-template>
  </app-generic-column>

  <app-generic-column key="place__name" [filterType]="FilterType.MSELECT" [filterOptions]="places" filterLabelField="name"
                      filterKey="place__id" filterValueField="id"
                      i18n-title="@@search-list-place" title="Place">
    <ng-template let-item>
      {{identity(item).place?.name}}
    </ng-template>
    <!-- define custom template for filter options -->
    <ng-template #filterOptionsTemplate let-place>
      {{place.admin_zone_2?.admin_zone_1?.country[this.filterLabelField]}}: {{place.name}}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="type" [filterType]="FilterType.MSELECT" [filterOptions]="documentTypeGroups" [group]="true"
                      filterLabelField="label" filterValueField="value.code" i18n-title="@@search-list-type" title="Type">
    <ng-template let-item>
      @if (identity(item).type; as type) {
        {{ utilitiesService.getLocalisedValue(type) }}
      }
    </ng-template>
  </app-generic-column>

  <app-generic-column key="date" i18n-title="@@search-list-date" title="Date" [filterType]="FilterType.DATE"></app-generic-column>

  <app-generic-column key="date_month" sortKey="date" i18n-title="@@search-list-month" title="Month" [filterType]="FilterType.MONTH">
    <ng-template let-item>
      {{  identity(item).date | date: 'yyyy-MM' }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="project_codes" i18n-title="@@search-list-project-codes" title="Project code(s)"></app-generic-column>

  <app-generic-column key="voucher_code" i18n-title="@@search-list-voucher-code" title="Voucher code"></app-generic-column>

  <app-generic-column key="budget_lines" i18n-title="@@search-list-budget-lines" title="Budget lines"
                      [showMatchModes]="false" matchMode="equals">
  </app-generic-column>

  <app-generic-column key="balzac_book__saga_name" i18n-title="@@search-list-balzac-code" title="Balzac code">
    <ng-template let-item>
      {{ identity(item).balzac_book?.saga_name }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="partner__name" i18n-title="@@search-list-partner-name" title="Partner">
    <ng-template let-item>
      {{ identity(item).partner?.name }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="asset_code" i18n-title="@@search-list-asset-code" title="Asset code"></app-generic-column>

  <app-generic-column key="asset_categories" i18n-title="@@search-list-asset-categories" title="Asset categories"
                      [filterType]="FilterType.MSELECT" [filterOptions]="assetCategories" [filterLabelField]="filterLabelField" filterValueField="value">
    <ng-template let-item>
      {{ identity(item).asset_categories?.join(', ') }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="warehouse_code" i18n-title="@@search-list-warehouse-code" title="Warehouse code"></app-generic-column>

  <app-generic-column key="supplier__code" i18n-title="@@search-list-supplier-code" title="Supplier code">
    <ng-template let-item>
      {{ identity(item).supplier?.code }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="supplier__name" i18n-title="@@search-list-supplier-name" title="Supplier name">
    <ng-template let-item>
      {{ identity(item).supplier?.name }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="landlord_code" i18n-title="@@search-list-landlord-code" title="Landlord code">
    <ng-template let-item>
      {{ identity(item).landlord?.code }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="landlord__full_name" i18n-title="@@search-list-landlord-name" title="Landlord name">
    <ng-template let-item>
      {{ identity(item).landlord?.full_name }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="document_number" i18n-title="@@search-list-document-number" title="Document number"></app-generic-column>

  <app-generic-column key="item_category" i18n-title="@@search-list-item-category" title="Item category"></app-generic-column>

  <app-generic-column key="order_form_date" i18n-title="@@search-list-order-form-date" title="Date of contract" [filterType]="FilterType.DATE"></app-generic-column>

  <app-generic-column key="staff_name" i18n-title="@@search-list-staff-name" title="Staff name"></app-generic-column>

  <app-generic-column key="third_party_code" i18n-title="@@search-list-third-party-code" title="Third party code"></app-generic-column>

  <app-generic-column key="homere_code" i18n-title="@@search-list-homere-code" title="Homere code"></app-generic-column>

  <app-generic-column key="activity" i18n-title="@@search-list-activity" title="Activity"></app-generic-column>

  <app-generic-column key="program_place__name" i18n-title="@@search-list-program-place" title="Program site">
    <ng-template let-item>
      {{ identity(item).program_place?.name }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="pmf_activity_number" i18n-title="@@search-list-pmf_activity_number" title="PMF activity number"></app-generic-column>

  <app-generic-column key="filename" i18n-title="@@search-list-filename" title="Filename"></app-generic-column>

  <app-generic-column key="created_by__email" i18n-title="@@search-list-created-by" title="Created by">
    <ng-template let-item>
      {{ identity(item).created_by?.email }}
    </ng-template>
  </app-generic-column>

  <app-generic-column key="created_at" i18n-title="@@search-list-created-at" title="Created at" [filterType]="FilterType.DATE">
    <ng-template let-item>
      {{ identity(item).created_at | date:'yyyy-MM-dd' }}
    </ng-template>
  </app-generic-column>


  <app-generic-column key="state" i18n-title="@@search-list-state" title="State" [filterType]="FilterType.MSELECT"
                      [filterOptions]="archiveDocumentWorkflowStates" [filterLabelField]="filterLabelField">
    <ng-template let-item>
      <app-workflow [api]="api" [disabled]="true" [state]="getWorkflowState(identity(item))"
                    [transitions]="[]" [workflowName]="identity(item).workflow" [code]="identity(item).uuid">
      </app-workflow>
    </ng-template>
  </app-generic-column>

</app-generic-list>
